import React from 'react'

const Home = () => (
  <div>
    Home Page
  </div>
)
export default Home
